import React from 'react';
import { Link } from 'react-router-dom';
import { HeartIcon } from '@heroicons/react/24/solid';

const Footer: React.FC = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-gray-50 border-t border-gray-200">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {/* Wedding Info */}
          <div className="text-center md:text-left">
            <h3 className="text-lg font-wedding text-gray-900 mb-4">
              Natalie & Avarokin
            </h3>
            <p className="text-gray-600 mb-2">
              Getting married soon!
            </p>
            <p className="text-gray-600">
              We can't wait to celebrate with you
            </p>
          </div>

          {/* Quick Links */}
          <div className="text-center">
            <h3 className="text-lg font-wedding text-gray-900 mb-4">
              Quick Links
            </h3>
            <div className="space-y-2">
              <div>
                <Link 
                  to="/rsvp" 
                  className="text-primary-600 hover:text-primary-700 transition-colors"
                >
                  RSVP
                </Link>
              </div>
              <div>
                <Link 
                  to="/details" 
                  className="text-primary-600 hover:text-primary-700 transition-colors"
                >
                  Wedding Details
                </Link>
              </div>
              <div>
                {/* Registry removed for now */}
              </div>
            </div>
          </div>

          {/* Contact */}
          <div className="text-center md:text-right">
            <h3 className="text-lg font-wedding text-gray-900 mb-4">
              Questions?
            </h3>
            <p className="text-gray-600 mb-2">
              Contact us for any questions
            </p>
            <p className="text-gray-600">
              about the wedding
            </p>
          </div>
        </div>

        {/* Bottom Section */}
        <div className="mt-8 pt-8 border-t border-gray-200">
          <div className="flex flex-col md:flex-row justify-between items-center">
            <div className="flex items-center text-gray-600 mb-4 md:mb-0">
              <span>Made with</span>
              <HeartIcon className="h-4 w-4 text-red-500 mx-1" />
              <span>for our special day</span>
            </div>
            <div className="text-gray-500 text-sm">
              © {currentYear} Natalie & Avarokin
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer; 